/* eslint-disable @reatom/unit-naming-rule */
import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { currencyRegistry } from '@root/entities/currency/atoms'
import { premiumMetaRegistry } from '@root/entities/premium/atoms'
import { reatomRequest } from '@root/shared/lib'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { checkCurrencyRequestAction } from './check-currency-requests'

import type { CurrencyAddress } from '@root/entities/currency'
import type { Network } from '@root/entities/network/model'

export const reatomCurrencyCheck = ({
  currency,
  network,
}: {
  currency: CurrencyAddress
  network: Network.Network
}) => {
  const execAction = action(async (ctx) => {
    const result = await ctx.schedule(() =>
      checkCurrencyRequestAction(ctx, { address: currency, network }),
    )

    const mappedResult = Result.map(result, (it) => {
      const currency = currencyRegistry.resolveFromTokenMeta(ctx, it.currency)
      return {
        currency: currency,
        hasPassedSecurityChecks: it.hasPassedSecurityChecks,
        premiumInfo: it.premiumInfo
          ? premiumMetaRegistry.resolve(ctx, {
              dto: it.premiumInfo,
              currency,
            })
          : undefined,
      }
    })

    if (Result.isFailure(mappedResult)) {
      showSnackbarAction(ctx, {
        text: i18next.t('premium.check.message.unknown-error'),
        description: i18next.t('common.something-went-wrong'),
        intent: 'error',
      })
    }

    return mappedResult
  })

  const stateAtom = reatomRequest({
    execAction,
    name: `${currency}.checkCurrencyRequestAction`,
  })

  return stateAtom
}

export type CheckCurrencyReatom = ReturnType<typeof reatomCurrencyCheck>
